import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
const DAY_MS = 24 * 60 * 60 * 1000;
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(DAY_MS);
  return <div className="sticky top-0 z-50 w-full border-b border-black/40 bg-alert text-white" data-id="element-136" data-mp="37u8k9adk0jcj">
      <div className="hazard-stripes" data-id="element-137" data-mp="32wgryf8zyv7t">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-2 px-4 py-2.5 text-center sm:flex-row sm:justify-center sm:gap-4 sm:text-left" data-id="element-138" data-mp="2yvesbxb64h5b">
          <p className="flex items-center gap-2 text-[13px] font-semibold leading-snug sm:text-sm" data-id="element-139" data-mp="2u33seugfgvcr">
            <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-140" data-mp="2p63kee00pij0" />
            <span data-id="element-141" data-mp="2k4ea50kmd8vz">
              <span className="font-bold uppercase" data-id="element-142" data-mp="2f7ebvbu0haff">Atención:</span> Evitá la
              próxima rotura de $2.000.000. Oferta de lanzamiento disponible
              solo por las próximas 24 horas.
            </span>
          </p>
          <p className="flex shrink-0 items-center gap-1 font-display text-base font-bold tabular-nums tracking-widest" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-143" data-mp="1rx155ojftshp">
            <span className="rounded bg-black/35 px-2 py-0.5" data-id="element-144" data-mp="1i0xzi8pdnbq0">{hours}</span>:
            <span className="rounded bg-black/35 px-2 py-0.5" data-id="element-145" data-mp="1myzjcvumnf2j">{minutes}</span>:
            <span className="rounded bg-black/35 px-2 py-0.5" data-id="element-146" data-mp="2aniqv95urntk">{seconds}</span>
          </p>
        </div>
      </div>
    </div>;
}